import React from "react";
import { Grid } from "@material-ui/core";
// import { ReactComponent as ERPLogo } from '~/assets/icons/erp.svg'
// import SVGIcon from "@components/SvgIcon";
import { motion, AnimatePresence } from "framer-motion";
interface Props {}

const LogoAnimation = (props: Props) => {
  return (
    <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
      {process.env.NODE_ENV !== "production" && <Grid item></Grid>}
      <Grid item>
        <AnimatePresence>
          <motion.div
            animate={{
              scale: [1, 1.0125],
              y: [5, 70],
              opacity: [0.85, 1],
              // boxShadow:`0px 0px 8px ${purple[500]}`,
              transition: {
                duration: 0.7,
                yoyo: Infinity,
                ease: "easeInOut",
              },
            }}
            exit={{ opacity: 0 }}
          >
            {/* <SVGIcon fontSize="40rem" svg={ERPLogo} /> */}
            <img src="/erp.png" width="100%" />
          </motion.div>
        </AnimatePresence>
      </Grid>
    </Grid>
  );
};

export default LogoAnimation;
